const normalizedId = (value) => (
  value === null || value === undefined || String(value).trim() === ''
    ? null
    : String(value).trim().toLowerCase()
);

/**
 * The scan an already-open 360 pane should show for a tag, before any nearest-scan fallback.
 *
 * The scan the tag was positioned from in this facility (`positionImage360Id`) wins over the
 * scan it was created from (`linked360ImageInfo`): a per-facility placement is the current
 * point's authority, the same ranking `rankTarget` applies in tagSpatialNavigation.js. Reading
 * only the creation link sent a tag placed from a 360 scan to the NEAREST scan instead of the
 * one it was placed from.
 *
 * @param {Object} tag - Tag being shown (positionImage360Id is resolved per facility by the API)
 * @param {Array<{id: string}>} images - The current facility's scans
 * @returns {Object|null} The matching scan, or null when neither id resolves here
 */
export function findTagSyncImage(tag, images = []) {
  const candidateIds = [tag?.positionImage360Id, tag?.linked360ImageInfo?.imageId]
    .map(normalizedId)
    .filter(Boolean);
  for (const candidateId of candidateIds) {
    const image = (images || []).find((img) => normalizedId(img?.id) === candidateId);
    if (image) return image;
  }
  return null;
}
